import { useEffect, useState } from 'react';
import { ButtonField } from '@wk/components-react16';
import { API_URL, API_USER } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import AddDimension from './model/AddDimension';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Privilege } from '../../config/constants/privilege';
import DeleteConfirm from '../../components/DeleteConfirm';
import { hideLoading, showLoading } from '../../store/authReducer';

const DimensionTab = () => {
    const dispatch = useDispatch();
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const [dimensionList, setDimensionList] = useState([] as any);
    const [isLoad, setIsLoad] = useState(false);
    const [selectedItem, setSelectedItem] = useState({} as any);
    const [isOpenAddEdit, setIsOpenAddEdit] = useState(false);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
    const [isEditPrivilege, setIsEditPrivilege] = useState(false);
    const [isDeletePrivilege, setIsDeletePrivilege] = useState(false);

    const addEdit = (item: any) => {
        setSelectedItem(item);
        setIsOpenAddEdit(true);
    }

    const getTaxonomyType = () => {
        dispatch(showLoading());
        HttpService.getRequest(`${API_URL.GET_TAXONOMY_TYPE_BY_PROJECT_ID}/${authProject.id}`).then(
        (res: any) => {
            dispatch(hideLoading());
            setDimensionList(res ? res : []);
        },
        (err: any) => {
            dispatch(hideLoading());
            Toast(err.message, "error");
        },
        )
    }

    const handleDelete = (item: any) => {
        setIsOpenDeleteConfirm(true);
        setSelectedItem(item);
    }

    const deleteItem = () => {
        HttpService.deleteRequest(`${API_URL.DELETE_TAXONOMY_TYPE}/${selectedItem.id}`).then(
            (res: any) => {
                Toast("Dimension deleted successfully.", "success");
                setIsLoad(true);
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
            },
            (err: any) => {
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
                Toast(err.message, "error");
            }
        )
    }

    useEffect(() => {
        if (isLoad) {
            getTaxonomyType();
            setIsLoad(false);
        }
    }, [isLoad]);

    useEffect(() => {
        if (authProject && authProject.id) {
            getTaxonomyType();
        }
    }, []);

    useEffect(() => {
        if (authUser && authUser.privileges) {
            setIsEditPrivilege(authUser.privileges.includes(Privilege[Privilege.EDIT_DIMENSION]));
            setIsDeletePrivilege(authUser.privileges.includes(Privilege[Privilege.DELETE_DIMENSION]));
        } else {
            setIsEditPrivilege(false);
            setIsDeletePrivilege(false);
        }
    }, [authUser]);

    return (
        <div className="p-20 wk-card-container mb-0 rounded-3 box-shadow">
            {isEditPrivilege && (
                <div className="wk-row">
                    <div className="wk-col-12 text-right">
                        <ButtonField size={'small'} mode={'ghost'}>
                            <button type="button" className="mr-5" onClick={() => addEdit({})}>
                                Add Dimension
                            </button>
                        </ButtonField>
                    </div>
                </div>
            )}
            <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th>Dimension Name</th>
                                <th style={{ width: '45%' }}>Code</th>
                                {(isEditPrivilege || isDeletePrivilege) && (<th style={{ width: '80px' }}>Actions</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {dimensionList.length > 0 ? dimensionList.map((item: any, index: number) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.code}</td>
                                    {(isEditPrivilege || isDeletePrivilege) && (
                                        <td>
                                            {isEditPrivilege && <span className="wk-icon-pencil mr-10 cursor" title="Edit"
                                                onClick={() => addEdit(item)}></span>}
                                            {isDeletePrivilege && <span className="wk-icon-trash cursor" title="Delete" onClick={() => handleDelete(item)}></span>}
                                        </td>
                                    )}
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={(isEditPrivilege || isDeletePrivilege) ? 3 : 2} className="text-center" style={{ height: '7rem' }}>
                                        No record found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {isOpenAddEdit && <AddDimension data={{ isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad }} />}
            {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete?` }} />}
        </div>
    );
};

export default DimensionTab;